import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import Userdashboardheader from './userdashboardheader/Userdashboardheader'
import './userdashboardwithdraw/userdashboardwithdraw.css'
import {AiOutlineArrowLeft} from 'react-icons/ai'
import Loader from './Loader'
import axios from 'axios'

const withdrawReviewToast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

const WithdrawReview = ({Active,withdrawAmount,closepage,route,funded}) => {
    const [wallet, setWallet] = useState('')
    const [amount] = useState(withdrawAmount)
    const [loader, setLoader] =  useState(false)
    const [cryptoAssets, setCryptoAssets] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);

    const navigate = useNavigate()

    useEffect(()=>{
        if(Active === undefined){
            navigate('/fundwallet')
            return;
        }

        const fetchCryptoAssets = async () => {
            try {
                const response = await axios.get(`${route}/crypto-assets/public/active`);
                if (response.data.status === 'ok') {
                    setCryptoAssets(response.data.assets);
                    if (response.data.assets.length > 0) {
                        setSelectedAsset(response.data.assets[0]);
                    }
                }
            } catch (error) {
                console.error('Error fetching crypto assets:', error);
                withdrawReviewToast.fire({
                    icon: 'error',
                    title: 'Failed to load withdrawal methods'
                });
            }
        };

        fetchCryptoAssets();
    },[route, Active, navigate])

    const withdraw = async () => {
        if (!selectedAsset) {
            withdrawReviewToast.fire({
                icon: 'error',
                title: 'Please select a withdrawal method'
            });
            return;
        }

        try {
            setLoader(true);
            const token = localStorage.getItem('token');
            
            const response = await axios.post(
                `${route}/withdrawal/create`,
                {
                    wallet: wallet,
                    amount: amount,
                    method: selectedAsset.symbol
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token
                    }
                }
            );

            const result = response.data;

            if (result.status === 'ok') {
                withdrawReviewToast.fire({
                    icon: 'success',
                    title: `Your withdrawal request of $${result.withdrawal.amount} has been placed successfully`
                });
                setWallet('');
                navigate('/withdrawlogs');
            } else {
                withdrawReviewToast.fire({
                    icon: 'warning',
                    title: result.message
                });
            }
        } catch (error) {
            withdrawReviewToast.fire({
                icon: 'error',
                title: error.response?.data?.message || 'Withdrawal request failed'
            });
        } finally {
            setLoader(false);
        }
    };

    return (
        <div>
            <Userdashboardheader route={route}/>
            {
            loader && 
              <Loader />
          }
            <div className="checkout-page">
            <div className="floating-btn" onClick={()=>{
                            closepage()
                        }}>
                            <AiOutlineArrowLeft />
                        </div>
                <h3>Withdrawal Preview</h3>
                <p>Review withdrawal details.</p>
                <div className="withdrawal-review-container">
                    <div className="left-withdrawal-review-card">
                        <div className="review-left-card-tab">
                            <p>Current Balance: <b>${funded ? funded.toFixed(2) : '0.00'} USD</b></p>
                        </div>
                        <div className="review-left-card-tab">
                            <p>Request Amount: <b>${amount ? amount.toFixed(2) : '0.00'} USD</b></p>
                        </div>
                        <div className="review-left-card-tab">
                            <p>Withdrawal Fee: <b>$0.00 USD</b></p>
                        </div>
                        <div className="review-left-card-tab">
                            <p>You Will Receive: <b>${amount ? amount.toFixed(2) : '0.00'} USD</b></p>
                        </div>
                        <div className="review-left-card-tab">
                            <p>Remaining Balance: <b>${funded && amount ? (funded - amount).toFixed(2) : '0.00'} USD</b></p>
                        </div>
                    </div>
                    <div className="right-withdrawal-review-card">
                        <div className="form-group">
                            <label>Select Withdrawal Method</label>
                            <select
                                value={selectedAsset?.symbol || ''}
                                onChange={(e) => {
                                    const asset = cryptoAssets.find(a => a.symbol === e.target.value);
                                    setSelectedAsset(asset);
                                }}
                                required
                            >
                                <option value="">Select withdrawal method</option>
                                {cryptoAssets.map(asset => (
                                    <option key={asset.symbol} value={asset.symbol}>
                                        {asset.name} ({asset.symbol})
                                    </option>
                                ))}
                            </select>
                        </div>
                        <form className="review-withdraw-form" onSubmit={(e) => {
                            e.preventDefault();
                            withdraw();
                        }}>
                            <label htmlFor="wallet">{selectedAsset ? `${selectedAsset.name} Wallet Address` : 'Wallet Address'}</label>
                            <input
                                type="text"
                                id='wallet'
                                placeholder='Enter wallet address'
                                onChange={(e) => setWallet(e.target.value.trim())}
                                required
                                value={wallet}
                            />
                            <input
                                type="submit"
                                value="Confirm Withdrawal"
                                className='confirm-withdraw-btn'
                                disabled={!selectedAsset}
                            />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WithdrawReview